import { render, staticRenderFns } from "./staffAddressBook.vue?vue&type=template&id=22f7e3c6&scoped=true"
import script from "./staffAddressBook.vue?vue&type=script&lang=js"
export * from "./staffAddressBook.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=22f7e3c6&prod&scoped=true&lang=css&external"
import style1 from "./staffAddressBook.vue?vue&type=style&index=1&id=22f7e3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f7e3c6",
  null
  
)

export default component.exports